import { render, staticRenderFns } from "./endorse.vue?vue&type=template&id=80e8be66"
import script from "./endorse.vue?vue&type=script&lang=js"
export * from "./endorse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports